import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const LabelsContext = createContext(void 0);
const LabelsProvider = ({ children, labels, language }) => {
  return /* @__PURE__ */ jsx(LabelsContext.Provider, { value: { labels, language }, children });
};
const useLabels = () => {
  const context = useContext(LabelsContext);
  if (context === void 0) {
    throw new Error("useLabels must be used within a LabelsProvider");
  }
  return context;
};
export {
  LabelsProvider,
  useLabels
};
